import React from 'react';
import './HomePage.css';

function HomePage({ setCurrentPage }) {
  const categories = [
    { 
      name: 'Baby Care', 
      icon: '👶',
      description: 'Safe & trusted products for your little ones',
      color: '#fbbf24'
    },
    { 
      name: 'Oral Hygiene', 
      icon: '🦷',
      description: 'Keep your smile bright & healthy',
      color: '#60a5fa'
    },
    { 
      name: 'Skin Care', 
      icon: '💆',
      description: 'Nourish & protect your skin naturally',
      color: '#f87171'
    },
    { 
      name: 'Health Supplements', 
      icon: '💊',
      description: 'Boost your immunity & wellness',
      color: '#34d399'
    }
  ];

  return (
    <div className="home-page">
      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="logo-area">
            <div className="logo-circle">💊</div>
            <h1 className="main-title">Disha Medical Store</h1>
            <p className="tagline">Your Trusted Health Partner Since 2000</p>
            
            <div className="cta-buttons">
              <button className="btn-primary" onClick={() => setCurrentPage('products')}>
                Shop Now ✨
              </button>
              <button className="btn-secondary" onClick={() => setCurrentPage('about')}>
                Learn More →
              </button>
            </div>
          </div>
          
          <div className="hero-text">
            <h2>Quality Healthcare Products at Your Doorstep</h2>
            <p>Discover a wide range of medicines, supplements, and wellness products from trusted brands</p>
          </div>

          <div className="hero-stats">
            <div className="stat">
              <h3>19+</h3>
              <p>Years of Service</p>
            </div>
            <div className="stat">
              <h3>10000+</h3>
              <p>Happy Customers</p>
            </div>
            <div className="stat">
              <h3>5000+</h3>
              <p>Products Available</p>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="medical-illustration">
            <div className="medicine-bottle animate-float">💊</div>
            <div className="medical-cross">+</div>
            <div className="capsule animate-float-delay">⚪</div>
          </div>
        </div>
      </section>

      {/* FEATURED CATEGORIES */}
      <section className="categories-section">
        <h2 className="section-title">Our Product Categories</h2>
        <p className="section-subtitle">Everything you need for your health & wellness</p>
        
        <div className="category-grid">
          {categories.map((cat, idx) => (
            <div 
              key={idx} 
              className="category-card-modern"
              style={{ borderTopColor: cat.color }}
              onClick={() => setCurrentPage('products')}
            >
              <div className="category-icon" style={{ backgroundColor: cat.color }}>{cat.icon}</div>
              <h3>{cat.name}</h3>
              <p>{cat.description}</p>
              <span className="explore-link">Explore →</span>
            </div>
          ))}
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="why-choose-us">
        <h2 className="section-title">Why Choose Disha Medical Store?</h2>
        
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">✅</div>
            <h3>Authentic Products</h3>
            <p>100% genuine medicines and supplements from authorized dealers</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">👨‍⚕️</div>
            <h3>Expert Guidance</h3>
            <p>B.Pharm qualified pharmacist available for consultation</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🚚</div>
            <h3>Easy Ordering</h3>
            <p>Simple checkout process with call/WhatsApp support</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">💰</div>
            <h3>Best Prices</h3>
            <p>Competitive pricing with regular offers and discounts</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🏪</div>
            <h3>Visit Us</h3>
            <p>Located in heart of Anand with convenient parking</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">⏰</div>
            <h3>Always Available</h3>
            <p>Serving the community since 2000 with trusted service</p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="testimonials-section">
        <h2 className="section-title">What Our Customers Say</h2>
        
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <div className="stars">⭐⭐⭐⭐⭐</div>
            <p>"Great quality products and excellent customer service. Highly recommended!"</p>
            <strong>- Rajesh Patel</strong>
          </div>

          <div className="testimonial-card">
            <div className="stars">⭐⭐⭐⭐⭐</div>
            <p>"The pharmacist is very knowledgeable and helped me choose the right supplement."</p>
            <strong>- Priya Sharma</strong>
          </div>

          <div className="testimonial-card">
            <div className="stars">⭐⭐⭐⭐⭐</div>
            <p>"Best medical store in Anand. Fast service and authentic medicines."</p>
            <strong>- Arun Kumar</strong>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="cta-final">
        <h2>Ready to Shop?</h2>
        <p>Browse our complete collection of medicines and wellness products</p>
        <button className="btn-cta" onClick={() => setCurrentPage('products')}>
          Browse All Products 🛍️
        </button>
      </section>
    </div>
  );
}

export default HomePage;